import { faClose, FaIcon, faUserSolid } from '@/lib/fa'
import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const AddActivityHeader = ({
  close,
  driverName,
}: {
  close: any
  driverName: string
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-p-4">
      <div className='tw-flex tw-items-center tw-gap-4'>
        <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
          {t('activities.add-new-activity')}
        </p>

        <div
          key={driverName}
          className="tw-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-base-300 tw-px-1 tw-py-1"
        >
          <FaIcon
            icon={faUserSolid}
            className="tw-h-3 tw-w-3"
            onClick={() => close()}
          />
          <p className="tw-text-xs tw-text-content-base">{driverName}</p>
        </div>
      </div>
      <FaIcon
        icon={faClose}
        className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer tw-text-content-base hover:tw-text-primary"
        onClick={() => close()}
      />
    </div>
  )
}
export default AddActivityHeader
